<template>  
  <div>    
  <b-modal
    id="view-visitor-modal"
    title="Contractor View Modal"
    centered
    hide-footer
    size="xl"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">View Contractors</h2>
    </template>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="users"
      details-td-class="m-0 p-0"
      small
      v-if="hasPermission('read_user')"
      :per-page="0"
    >
      <template #cell(role_data)="row">
        {{ row.item.role_data ? row.item.role_data.name : "" }}
      </template> 
      <template #cell(profile_status)="row">
        <b-badge :variant="badgeVariant(row.item.profile_status)">
          {{ row.item.profile_status }}
        </b-badge>
      </template>
      <template #cell(manage)="row">
        <b-dropdown pill size="sm" :hidden="row.item.profile_status != 'Pending' ? true:false"  text="Change Status" variant="info" class="" v-if="hasPermission('update_user')">
          <b-dropdown-item :hidden="row.item.profile_status === 'Approved' ? true:false" @click="changeStatus(row.item, 'Approved')">Approve</b-dropdown-item>
          <b-dropdown-item :hidden="row.item.profile_status === 'Rejected' ? true:false" @click="changeStatus(row.item, 'Rejected')">Reject</b-dropdown-item>
          <!-- <b-dropdown-item :hidden="row.item.profile_status === 'Pending' ? true:false" @click="changeStatus(row.item, 'Pending')">Pending</b-dropdown-item> -->
          <!-- <b-dropdown-item :hidden="row.item.profile_status === 'Left' ? true:false" @click="changeStatus(row.item, 'Left')">Left</b-dropdown-item> -->
        </b-dropdown>
      </template>
    </b-table>
    <b-pagination
      size="md"
      :total-rows="totalItems"
      v-model="currentPage"
      :per-page="perPage"
    ></b-pagination>
  </b-modal>  
  </div>  
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  props: { building: Object },
  mixins: [util],
  data() {
    return {
      required,
      fields: [
        { key: "name", label: "Full Name" },
        { key: "username", label: "Username" },
        { key: "mobile_number", label: "Mobile" },
        { key: "email", label: "Email" },
        { key: "role_data", label: "Role" },
        { key: "profile_status", label: "Status" },
        { key: "manage", label: "Manage" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      user: {},
      users: [],
      editVisitorModalCount: 0,
    };
  },
  methods: {
    ...mapActions({
      getUsers: "appData/getUsers",
      updateUser: "appData/updateUser",
    }),
    async fetchPaginatedData() {
      try {
        const res = await this.getUsers({
          pageNumber: this.currentPage,
          status: 'Visitor',
        });
        this.users = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
        this.$emit("modalClosed");
      } catch (error) {
        this.displayError(error);
      }
    },
    badgeVariant(status) {
      switch (status) {
        case 'Approved':
          return 'success';
        case 'Rejected':
          return 'danger';
        case 'Pending':
          return 'warning';
        case 'Left':
          return 'dark';
        default:
          return 'light';
      }
    },

    async changeStatus(data, profile_status){      
      try {
        const formData = new FormData();
        formData.append("profile_status", profile_status);        
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.updateUser({
          payload: formData,
          pk: data.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Status Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          await this.fetchPaginatedData();          
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    

  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission", getLoggedInUser: "appData/getLoggedInUser"
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
  async mounted(){
    await this.fetchPaginatedData();
  }
};
</script>

<style></style>
